module.exports = __webpack_public_path__ + "img/mobile/MenusContent/settings_active@2.25x.png?1.0.6";